// A contact can be known by its phone, by WhatsApp's internal id (LID), or both.
// When WhatsApp does not reveal the phone, the stored "number" is the LID digits.

const digits = (value) => String(value || "").replace(/\D/g, "");

export const contactIds = (contact) => {
	const lid = digits(contact && contact.lid);
	const number = digits(contact && contact.number);
	const lidOnly = !!lid && lid === number;

	return {
		phone: lidOnly ? "" : number,
		lid,
		lidOnly,
	};
};
